"use client";

export {
  LocationDynamic,
  Location,
  LocationSolid,
} from "./deprecated/Location";
